import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IRecipeBlock } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class RecipeBlockService extends BaseService<IRecipeBlock> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'recipeBlock');
  }
}

export { IRecipeBlock } from '../shared/api';
